module.exports = __webpack_public_path__ + "img/stripe-2.4c660fa5.svg";